module.exports = __webpack_public_path__ + "img/store_vip_benefit_speed.debc3167.png";